import './Auth.css';
import {CheckUserProfileCompletion, LoginUserUsingEmail} from '../../services/auth.jsx';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import { useNavigate } from 'react-router-dom';
import google from '../../Assets/Images/RegisterPage/social.png';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import logo from '../../Assets/logo.png';
import bg from '../../Assets/Images/RegisterPage/background.png';

function Login(){
    
    const [emailLabel,setEmailLabel]=useState("");
    const [passwordLabel,setPasswordLabel]=useState("");
    const [error,setError]=useState('');
    const [token,setToken]=useState(Cookies.get('token'));


  async function SaveForm(e) {
    e.preventDefault();
    var formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    if(!data.email && !data.password) {
        setError("Email or Password can not be empty!")
        return;
    }

    if(!data.email) {
        setEmailLabel("Email Required!");
        return;
    }
    
    if(!data.password) {
        setPasswordLabel("Password Required!");
        return;
    }

    try {
        const login = await LoginUserUsingEmail(data);
        
        if (login && login.success) {
            const { _id, role } = login;
            
            //  Handle navigation based on role HERE
            if(role === "superadmin" || role === "companyadmin") {
                // Admin users go to admin panel
                window.location.href = process.env.REACT_APP_ADMIN;
            } else {
                // Regular users - check profile completion
                try {
                    const profileCompletedFetch = await CheckUserProfileCompletion(_id);
                    
                    if (profileCompletedFetch && profileCompletedFetch.success) {
                        navigate('/homepage');
                    } else {
                        navigate('/profilesetup');
                    }
                } catch (profileError) {
                    console.error("Profile check failed", profileError);
                    navigate('/profilesetup');
                }
            }
        } else {
            setError(login?.message || "Login failed. Please try again.");
        }
    } catch (error) {
        setError("An error occurred, please try again later.");
        console.error("Login failed", error);
    }
}


  useEffect(() => {
        if(token) {
            const role = Cookies.get('role'); 
            
            if(role === "superadmin" || role === "companyadmin") {
                window.location.href = '/admin';
            } else if(role === "user") {
                navigate('/profilesetup');
            } else {
                navigate('/login');
            }
        } else {
            navigate('/login'); 
        }
    }, [token]);


    const navigate = useNavigate();
    return(
        <>
             <div className='registercontainer'>
                     <div className='registerleft_part'>
                                   <img src={logo} alt='logo' className='logo'/>
                                   <img src={bg} alt='backgroundImage'/>
                                </div>
            <div className='registerright_part'>
                     <div className='text'>
                        <h2>Login</h2>
                        <h3>Login with your email and password </h3>
                     </div>
                    <form onSubmit={(e)=>SaveForm(e)} >
                           <section className='inputsection'>
                              <div className="inputSubSection">
                               <h3>Email Address</h3>
                                <div className='inputfield'>
                                  <input type='email' name='email' placeholder='Email'/>
                                </div>
                              </div>
                                 <div className="inputSubSection">
                               <h3>Password</h3>
                                <div className='inputfield'>
                                    <input type='password' name='password' placeholder='Password'/>
                                </div>
                              </div>
                              <section className='forgotsection'>
                                <div>
                                    <input type='checkbox' name='remember'/>
                                    <label htmlFor='remember' style={{marginLeft:"5px"}}>Remember Me</label>
                                </div>
                                 <h4 onClick={()=>window.location.href="/resetpassword"} style={{cursor:'pointer',color:'#8A090D'}}> Forgot Password?</h4>
                              </section>
                                  <section className='loginbuttons'>
                            <label style={{marginBottom:"10px",color:'var(--border-color)'}}>{error}</label>
                                <button className='loginbutton' style={{marginBottom:"20px"}}>LOGIN</button>
                                {/* <div className='orsection'>
                                    <hr  className="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  className="custom-hr"/>
                                </div>
                                <button className='continuephone' onClick={()=>navigate('/otplogin')}>CONTINUE WITH PHONE NUMBER</button> */}
                            </section>
                           </section>
                       
                    </form>
                    {/* <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} alt='linkedIn' width="38" height="38"/>
                            </section> */}
                            {/* <h4> New User? <span  onClick={()=>window.location.href="/register"}>Register here</span></h4> */}
             </div>
                </div>
        </>
        );

}
export default Login;